module.exports = __webpack_public_path__ + "img/u112.9e5bb322.svg";